import React, { createContext, useContext, useState } from 'react';

const BalanceContext = createContext();

export const useBalance = () => {
  const context = useContext(BalanceContext);
  if (!context) {
    throw new Error('useBalance must be used within a BalanceProvider');
  }
  return context;
};

export const BalanceProvider = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const triggerRefresh = () => {
    setRefreshTrigger(prev => prev + 1);
  };

  return (
    <BalanceContext.Provider value={{ refreshTrigger, triggerRefresh }}>
      {children}
    </BalanceContext.Provider>
  );
};